import { SectionCard } from "../../../components/SectionCard";
import { LanguageSelect } from "../../../components/LanguageSelect";
import { useLanguage } from "../../../contexts/LanguageContext";
import { settingsLabels } from "../labels";

export function LanguageSection() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].language;

  return (
    <SectionCard header={<div className="font-semibold">{t.header}</div>}>
      <div className="flex flex-col gap-2">
        <LanguageSelect labels={t.options} className="w-40" />
        <p className="text-sm text-neutral-500">{t.description}</p>
      </div>
    </SectionCard>
  );
}
